import { Component, ElementRef, ViewChild, Renderer2, OnInit, Input } from '@angular/core';

@Component({
    selector: 'hub-learn-cta',
    templateUrl: './hub-learn-cta.component.html',
    styleUrls: ['./hub-learn-cta.component.scss']
})

export class HubLearnCtaComponent {

}